'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPencilToRectangle, iconPencilToRectangleTag } from '@ni/nimble-components/dist/esm/icons/pencil-to-rectangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPencilToRectangle };
export { iconPencilToRectangleTag };
export const NimbleIconPencilToRectangle = wrap(IconPencilToRectangle);